/** @jsxImportSource @emotion/react */
import { FormControlLabel, Switch as MuiSwitch, SwitchProps, FormControlLabelProps } from '@mui/material'
import { FC } from 'react'
import * as classes from './styles'

export type Props = {
  switchProps?: SwitchProps
} & Omit<FormControlLabelProps, 'control'>

export const Switch: FC<Props> = ({ switchProps, ...rest }) => (
  <FormControlLabel control={<MuiSwitch {...switchProps} />} {...rest} css={classes.switchElement} />
)
